<template>
    <header id="header" class="navbar navbar-dark sticky-top flex-md-nowrap">
        <a id="logo-link" class="navbar-brand col-md-3 col-lg-2 me-0" href="/">
            <img id="logo-1" src="/themes/web/assets/images/logo.png" alt="">
        </a>

        <div class="container">
            <div class="header-content">
                <div class="header-avatar-body">
                    <div class="header-avatar">
                        <div class="account-menu">
                            <ul class="nav nav-pills" style="margin-left:0px">
                                <li class="nav-item dropdown">
                                    <div class="nav-link dropdown-toggle" @click="toggleDropdown">
                                        <div class="d-flex">
                                            <div class="thumb">
                                                <div class="thumb-content"  @mouseover="showText" @mouseleave="hideText">
                                                    <img class="avatar" src="/themes/web/assets/images/avatar-free-trial.svg" alt="" v-if="user.student_type == 2"/>
                                                    <img class="avatar" :src="user.avatar_url" alt="" v-else />
                                                    <div style="z-index: 9999; width: 200px;height: 100%;position: absolute;"/>
                                                </div>

                                                <img class="emotion" :src="user.emoji_url" alt="" v-if="user.emoji_url"/>
                                            </div>
                                            <div style="display: flex;flex-direction: column;" class="hello">
                                                <span class="username ">{{ user.fullname || user.username }}</span>
                                                <div class="user-name" id="dropdownMenuButton2" data-mdb-toggle="dropdown" aria-expanded="false">

                                                    <RouterLink :to="{name: 'profile'}" class="status warning"
                                                        v-if="!user.email_verified || !user.phone_verified">
                                                        <img src="/themes/web/assets/images/icon-warning.svg" alt="">
                                                        <i class="ito-icon-warning"></i>
                                                        {{ $t('account_not_verified') }}
                                                    </RouterLink>
                                                </div>
                                                <div class="dropdown-menu profile_actions_2 test show" style="top: 20px;" aria-labelledby="dropdownMenuButton2" v-if="(!user.email_verified || !user.phone_verified) && !dismissVerify">
                                                    <span @click.stop="dismissVerify = true" style="position: absolute; right: 10px; top: 5px; cursor: pointer; font-size: 20px; color: #666; z-index: 10; line-height: 1;">&times;</span>
                                                    <div class="d-flex flex-column justify-content-center align-items-center text-center">
                                                        <img src="/themes/web/assets/images/mascot/account_not_verify.png" alt="">
                                                        <p class="text-bold fs-6" v-html="$t('verify_reward_annoucement')"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%;height: 100%;position: absolute;"/>
                                    <ul @mouseover="showText" @mouseleave="hideText" :class="{ 'show-text': isHovered }" class="dropdown-menu" style="margin-top:22px;">
                                        <li>
                                            <router-link :to="{ name: 'profile' }" class="dropdown-item">
                                                <i class="lisa-icon-account-profile"></i> {{ $t('profile') }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" data-bs-toggle="modal"
                                               data-bs-target="#selectLangModal">
                                                <i class="lisa-icon-account-language"></i>
                                                <span>{{ $t('language') }}</span>
                                                <img class="flag" :src="flag_url" alt=""/>
                                            </a>
                                        </li>
                                        <!-- <li v-if="user.account_type != 1">
                                            <router-link class="dropdown-item" :to="{ name: 'exchange_gift' }">
                                                <i class="lisa-icon-account-exchange-gift"></i> {{ $t('exchange_gift')
                                                }}
                                            </router-link>
                                        </li> -->
                                        <li>
                                            <a class="dropdown-item upgrade" @click="upgradeAccount()">
                                                <i><img class="icon-upgrade" src="/themes/web/assets/images/icon-upgrade.svg" alt=""></i>
                                                <span>{{ $t('upgrade_account') }}</span>
                                            </a>
                                        </li>
                                        <!-- <li>
                                            <a class="dropdown-item" href="#" data-bs-toggle="modal"
                                               data-bs-target="#settingModal">
                                                <i class="lisa-icon-account-setting"></i> <span>{{$t('settings')}}</span>
                                            </a>
                                        </li> -->
                                        <li>
                                            <a class="dropdown-item" href="#" @click="onLogout">
                                                <i class="lisa-icon-account-logout"></i>
                                                <span>{{ $t('log_out') }}</span>
                                            </a>
                                        </li>

                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="header-info">
                    <ul class="navbar-nav me-auto mb-2 mb-md-0">
                        <li class="nav-item">
                            <a class="nav-link" href="/register?type=student" @click.native="getSoundClick"
                                         v-if="user.student_type == 2">
                                <div class="btn btn-htool save-account">
                                    <img class="icon-info-right" src="/themes/ito/images/icons/icon-save-account.svg">
                                    <div class="label" style="color:#ffffff">{{$t('save_account')}}</div>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <button class="btn btn-htool" data-dismiss="modal" data-toggle="modal" data-target="#updateGradeModal" @click="openGradeModal">
                                    <i class="lisa-icon-header-grade"></i>
                                    <div class="label">{{ user.grade }}</div>
                                </button>
                            </a>
                        </li>
                        <!--<div class="box-shadow-main d-flex align-items-center box-info-right box-level" data-dismiss="modal" data-toggle="modal" data-target="#updateGradeModal" @click="getSoundClick">-->
                            <!--<img class="icon-info-right" src="/themes/ito/images/icon-league.svg">-->
                            <!--<span>{{ user.grade }}</span>-->
                        <!--</div>-->
                        <li class="nav-item" v-if="user.account_type != 1 && user.student_type != 2">
                            <router-link :to="{ name: 'leaderboard' }" @click.native="getSoundClick" class="nav-link">
                                <button class="btn btn-htool">
                                    <i class="lisa-icon-header-chart"></i>
                                    <div class="label">{{ user.contest_info.id == 0 && user.rank > 0 ? user.rank : $t('rank') }}</div>
                                </button>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="user.account_type == 1">
                            <a class="nav-link" href="#">
                                <button class="btn btn-htool gap-1">
                                    <AppIcon :src="$store.state.gem_icon_url" :size="21" />
                                    <span>{{ user.contest_info.id != 0 ? user.contest_info.total_gem : user.gem | toCommas }}</span>
                                </button>
                            </a>
                        </li>
                        <li class="nav-item" v-else>
                            <router-link :to="{ name: 'daily_challenge' }" @click.native="getSoundClick" class="nav-link">
                            <!-- <a class="nav-link" href="#" @click="gotoDailyChallenge"> -->
                                <button class="btn btn-htool gap-1" style="padding-right: 0;">
                                    <AppIcon :src="$store.state.gem_icon_url" :size="21" />
                                    <span>{{ user.contest_info.id != 0 ? user.contest_info.total_gem : user.gem | toCommas }}</span>
                                    <div><img style="margin-left:8px; " src="/themes/ito/images/icon-add.svg" alt=""></div>
                                    <div class="noti-alert" v-if="user.first_login == 1 || user.dailychallenge_noti != 0"></div>
                                </button>

                            <!-- </a> -->
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="header-search-form"  v-if="user.account_type != 1 && user.student_type != 2">
                    <form method="get" action="/search">
                        <input type="text" name="q" :placeholder="$t('search')" id="q" v-model="searchInput"/>

                        <i class="lisa-icon-header-search"></i>
                        <i class="lisa-icon-search-close"  @click.stop="searchInput ='' "></i>
                    </form>
                </div>
            </div>
        </div>

        <!-- <div class="header-help">
            <router-link :to="{ name: 'faq' }" @click.native="getSoundClick" class="nav-link nav-link-help">
                <button class="btn btn-help">
                    <i class="lisa-icon-header-help"></i>
                    <span style="margin-left:6px">{{$t('help')}}</span>
                </button>
            </router-link>
        </div> -->
    </header>
</template>

<script>
    import { RouterLink } from "vue-router";
import {getLanguage, soundClick} from "../utils/utils";
    import AppIcon from "@/components/common/AppIcon.vue";

    export default {
        name: "NavBar",
        components: {
            AppIcon
        },

        data() {
            return {
                locate: getLanguage(),
                locate_info: null,
                localizes: null,
                search: '',
                searchInput:'',
                isHovered: false,
                dismissVerify: false,
            };
        },

        computed: {
            user() {
                return this.$store.state.user_info;
            },
            configs() {
                const conf = this.$store.state.configs
                this.locate = getLanguage();
                this.localizes = conf.localize || [];

                this.localizes.forEach(item => {
                    if (item.lang == this.locate) {
                        this.locate_info = item;
                    }
                });

                return this.$store.state.configs
            },
             flag_url() {
            const lang = this.$i18n.locale;
            const flag = this.configs.localize.find(item => item.lang == lang)?.img_flag;
            return flag;
        }
        },

        created() {
            this.fetch();
        },
        mounted() {
            if (this.$route.query.keyword) {
                this.search = this.$route.query.keyword;
            }
            document.addEventListener("click", this.hideDropdown);
        },
        beforeDestroy() {
            document.removeEventListener("click", this.hideDropdown);
        },
        methods: {
            toggleDropdown() {
                this.isHovered = !this.isHovered;
            },
            hideDropdown(event) {
                const dropdown = this.$el.querySelector(".dropdown-menu");
                const toggle = this.$el.querySelector(".dropdown-toggle");

                if ((dropdown && dropdown.contains(event.target)) || (toggle && toggle.contains(event.target))) {
                    return;
                }

                this.isHovered = false;
            },
            upgradeAccount(){
                if (this.user.placement_test != 0){
                    const path = '/upgrade-account'
                    this.$router.push(path)
                }else{
                    $('#placementModal').modal('show');
                }
            },
            fetch() {
                this.user.grade = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user.grade;
            },

            onLogout(e) {
                window.boChatbot?.newSession()
                this.$store.dispatch('logout').then(() => {
                    localStorage.removeItem("banner_hidden");
                    localStorage.removeItem("grade");
                    localStorage.removeItem("subjects_checked_1");
                    window.location.href = "/login";
                    // this.$router.push("/login")
                });
                // localStorage.removeItem('grade');
                e.preventDefault();
            },

            gotoDailyChallenge() {
                if(this.user.account_type != 1 && this.user.account_type != 2){
                    //return;
                }
                //window.location.href = '/daily-challenge';

                this.$router.push({name: 'daily_challenge'})
            },

            getSoundClick() {
                soundClick();
            },
            openGradeModal(){
                soundClick();
                $('#updateGradeModal').modal('show');
            },
            showText() {
                console.log("ssss");
                this.isHovered = true;
            },
            hideText() {
                this.isHovered = false;
            },
            handleSubmit() {
                // const path = `/search/${this.search}`
                this.$router.push({
                    path: "/search",
                    query: {
                        keyword: this.search,
                        t: new Date().getTime(),
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .noti-alert {
        position: absolute;
        right: -5px;
        bottom: -5px;
    }
    .noti-alert {
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 100%;
        background: #FA450F;
        border: 2px solid #ffffff;
        pointer-events: none;
    }
    .header-search-form input{
        box-shadow: none;
        border: 1px solid #CCD2E3;
    }
    .dropdown-item.upgrade{
        padding: 10px 22px !important;
    }
    .icon-upgrade{
        width: 23px;
        line-height: 18px;
        /* background-image: url(/public/themes/ito/images/icon-upgrade.svg);
        background-position: 0px 0px;
        background-repeat: no-repeat;
        display: inline-block;
        vertical-align: sub; */
    }
    .nav-link.dropdown-toggle{
        padding: 0 !important;
    }
    .btn.btn-htool{
        position: relative;
        display: flex;
        align-items: center;
        height: 44px;
        border: 1px solid #CCD2E3;
        box-shadow: none;
    }
    .btn.btn-htool .label{
        height: 100%;
        color: #1F4083;
        margin-left: 4px;
    }
    .btn.btn-htool.save-account{
        padding: 11px 12px;
        font-weight: 700;
        background: linear-gradient(180deg, #40C0F6 0%, #28B5F0 100%);
        box-shadow: 4px 2px 20px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
    }
    .btn.btn-htool.save-account .label{
        margin-left: 10px;
    }
    .lisa-icon-header-grade{
        width: 31px;
    }
    .btn.btn-help{
        display: flex;
        align-items: center;
        justify-content:center;
        height: 40px;
        width: 135px;
    }
    .lisa-icon-header-help{
        font-weight: 700;
    }
    .header-help{
        width: 135px;
    }
    #logo-link{
        position: absolute;
        width: 135px;
    }
    #logo-1{
        /* height: 115px; */
        width: 100%;
    }
    .header-content .header-avatar-body>.header-avatar .thumb img.avatar{
        border-radius: 8px;
    }
    /* @media (max-width: 1400px) {
        .header-content{
            width: 942px;
            margin-left: 45px;
        }
    } */
    .dropdown-menu li a{
        color: #212529;
    }
    .dropdown{
        cursor: pointer;
    }
    .hello:hover .dropdown-menu{
        display: block;
    }
    .lisa-icon-search-close{
        top: 15px !important;
        margin: 0;
        cursor: pointer;
    }
    /* .status {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        text-decoration: underline;
        gap: 3px;
    } */

    .status.warning {
        color: #FA450F;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        text-decoration: underline;
        gap: 3px;
    }
    /* .dropdown-menu.test{
        display: none;
    } */
    /* .dropdown-menu:hover .dropdown-menu.test{
        display: block !important;
    } */
    .show-text {
    display: block;
    }
</style>
